import moment from 'moment-timezone';

export default function(TimeZoneClass) {
  'ngInject';
  const guessedTimezone = moment.tz.guess();

  return (date, timezoneId = guessedTimezone) => {
    try {
      if (!moment(date)._isValid) {
        return '';
      }

      return moment.tz(date, timezoneId).format('ll h:mm a ') + TimeZoneClass.abbr(date, timezoneId).text; // Mar 4, 2021 5:00 am PDT
    } catch (error) {
      return date;
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/filters/PrettyDateTime.js